import React from 'react';
import './WhatsAppButton.css';

// ⚠️ SET YOUR NUMBER HERE (country code + number, digits only, no + or spaces)
// e.g. 919876543210 for +91 98765 43210
// You can also set REACT_APP_WHATSAPP_NUMBER in frontend/.env instead.
const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || '918106997254';

const DEFAULT_MESSAGE = 'Hi Bhumi Old School Foods! I have a question about your products.';

const WhatsAppButton = () => {
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(DEFAULT_MESSAGE)}`;

  return (
    <a
      href={href}
      className="whatsapp-fab"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      title="Chat with us on WhatsApp"
    >
      <svg viewBox="0 0 32 32" width="30" height="30" fill="currentColor" aria-hidden="true">
        <path d="M16.004 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.26.594 4.466 1.72 6.408L3.2 28.8l6.56-1.688a12.74 12.74 0 0 0 6.24 1.622h.006c7.058 0 12.794-5.74 12.794-12.8 0-3.42-1.33-6.634-3.75-9.05a12.71 12.71 0 0 0-9.046-3.684zm0 23.376h-.004a10.6 10.6 0 0 1-5.4-1.478l-.388-.23-3.894 1.002 1.04-3.796-.254-.39a10.56 10.56 0 0 1-1.63-5.684c0-5.868 4.776-10.642 10.65-10.642 2.844 0 5.516 1.108 7.526 3.12a10.58 10.58 0 0 1 3.114 7.53c-.002 5.868-4.778 10.568-10.76 10.568zm5.84-7.96c-.32-.16-1.894-.934-2.188-1.04-.294-.108-.508-.16-.72.16-.214.32-.828 1.04-1.014 1.254-.186.214-.374.24-.694.08-.32-.16-1.352-.498-2.574-1.588-.952-.848-1.594-1.896-1.78-2.216-.186-.32-.02-.494.14-.652.144-.144.32-.374.48-.56.16-.188.214-.32.32-.534.106-.214.054-.4-.026-.56-.08-.16-.72-1.734-.986-2.374-.26-.624-.524-.54-.72-.55-.186-.008-.4-.01-.614-.01-.214 0-.56.08-.854.4-.294.32-1.12 1.094-1.12 2.668 0 1.574 1.146 3.094 1.306 3.308.16.214 2.256 3.444 5.466 4.83.764.33 1.36.526 1.824.674.766.244 1.464.21 2.016.128.614-.092 1.894-.774 2.16-1.522.268-.748.268-1.388.188-1.522-.08-.134-.294-.214-.614-.374z"/>
      </svg>
    </a>
  );
};

export default WhatsAppButton;
